<template lang="pug">
  .history-info(v-loading="loading")
    .history-info__content
      el-card.history-info__item(
        v-for="item,index in data.experience"
        :key="index"
      )
        .history-info__item__content
          .history-info__item__content__summary
            .left
              el-tooltip(
                :content="item.campaign_name"
                placement="top"
              )
                p {{ item.campaign_name }}
            .divider
            .right
              div
                span
                  span {{ $t('Function') }}:
                  span {{ functionMap[item.function_type] }}
                span
                  span {{ $t('项目预算') }}:
                  span {{ item.budget | formatMoney }}
              div
                span
                  span {{ $t('上线时间') }}:
                  span {{ item.start_date | formatDate }} ~ {{ item.end_date | formatDate }}
              div
                span(
                  style="width: 100%"
                )
                  span {{ $t('品类/品牌') }}:
                  span(
                    v-for="(i, idx) in item.brand"
                  )
                    span {{ i.brand_category_name }} - {{ i.brand_name }}
                      span(v-if="idx !== item.brand.length - 1") 、
        hr.history-info__divider
        rate-item-container(:item="item")
    no-data(v-if="data && data.experience.length === 0")
</template>

<script>
import axios from 'axios'
import NoData from '@/components/NoData'
import { formatMoney, formatDate } from '@/umcc/util'
import RateItemContainer from './children/RateItemContainer'

export default {
  components: {
    NoData,
    RateItemContainer
  },
  data () {
    return {
      functionMap: {
        1: 'Brand',
        2: 'EC',
        3: 'CD'
      },
      data: {
        overall: 0,
        experience: []
      },
      loading: false
    }
  },
  computed: {
    vendorId () {
      return this.$store.state.vendor.id
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      axios
        .get('/vendor/client/getVendorExperienceWithUni', {
          params: {
            vendor_id: this.vendorId
          }
        })
        .then(res => {
          this.data = res
          this.data.overall = Number(res.overall.toFixed(1))
          this.data.experience.forEach((item, index) => {
            item.overall = Number(item.overall.toFixed(1))
          })
          this.loading = false
        })
    }
  },
  filters: {
    formatMoney: formatMoney,
    formatDate,
    formatRate (value) {
      return [
        {
          rate: value.satisfaction,
          name: '客户服务满意度'
        },
        {
          rate: value.execution,
          name: '执行能力'
        },
        {
          rate: value.development,
          name: '开发能力'
        },
        {
          rate: value.creativity,
          name: '创意能力'
        },
        {
          rate: value.cost_control,
          name: '成本控制'
        },
        {
          rate: '',
          name: 'hahahahah'
        }
      ]
    }
  }
}
</script>

<style lang="stylus">
.history-info__content
  display: flex
  flex-direction column
  .el-card__body
    padding 24px !important
.history-info__item
  margin-bottom 22px
.history-info__item__title
  display flex
  justify-content space-between
  margin-bottom 10px
  > span:nth-child(1)
    color $main
  > span:nth-child(2)
    > span:nth-child(1)
      margin-right 10px

.history-info__item__content
  border-radius 5px
  border-bottom-left-radius 0
  border-bottom-right-radius 0
  .history-info__item__content__summary
    display flex
    align-items center
    .left
      width 190px !important
      text-align center
      p
        font-size 22px
        margin 0
        color $black2
        overflow hidden
        width 100%
        text-overflow ellipsis
        white-space nowrap
        font-weight 600
      .el-rate
        line-height 12px
    .right
      width calc(100% - 350px)
      div
        display flex
        // flex-direction column
        // width 50%
        > span
          display flex
          align-items center
          margin-bottom 15px
          color $black1
          height 22px
          width 50%
          line-height 22px
          > span:nth-child(1)
            color $black2
            display inline-block
            text-align left
            margin-right 10px

    .divider
      border-right 1px solid $gray2
      height 59px
      margin 0 57px
.history-info__header
  p
    margin 0 0 5px
    display inline-block
    margin-right 12px
    font-size 24px
    color #ffc174
  .el-rate
    vertical-align text-bottom
    display inline-block
    line-height 12px
    height 24px
  .rate-item-container
    margin-bottom 22px
    .rate-item
      background #ffdfb7

.history-info__divider
  border-top none
</style>
